module.exports = __webpack_public_path__ + "img/electrify-america-solar-glow-1.d3682c92.webp";